import { Vue, Component } from 'vue-property-decorator';
import SampleConfiguration from '@/app/models/SampleConfiguration';

export interface ProgressConfig {
    min: number;
    max: number;
}

@Component
export default class ProgressMixin extends Vue {
    sampleConfigurations: SampleConfiguration[]|null = null;

    async beforeMount() {
        // @ts-ignore
        this.sampleConfigurations = (await SampleConfiguration.index()).data;
    }

    getProgress(total_brands: number): ProgressConfig {
        // Special case for less than 5 brands
        if (total_brands < 5) {
            return { min: total_brands, max: total_brands };
        }

        if (!this.sampleConfigurations) return { min: 0, max: 0 };

        const config = this.sampleConfigurations.find(config => 
            total_brands >= config.min_elements && 
            total_brands <= config.max_elements
        );

        if (!config) return { min: 0, max: 0 };

        return {
            min: config.min_samples,
            max: config.max_samples
        };
    }
} 